import React, {PropsWithChildren} from 'react';
import {Box} from '@mui/material';

const BodyToaster = ({children, title}: PropsWithChildren<{ title: string }>) => {
  return <Box px={2} py={2}>
        <Box paddingRight="30px">
            <Box className="Toastify__toast-body-title" component={'span'}>{title}</Box>
        </Box>
    <Box className="Toastify__toast-body-text" py={4}>{children}</Box>
  </Box>;
};

export default BodyToaster;
